var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('messages-list',{attrs:{"api-url":_vm.apiUrl,"table-columns":_vm.tableColumns}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }